import { useState } from "react";

import { useHistory } from "react-router-dom";

import Box from "@/components/Box";
import Circle from "@/components/Circle";
import ChevronComponent from "@/tpo/Chevron";
import Menu from "@/tpo/Menu";
import ButtonV2 from "@/v2/Buttons";
import styled from "styled-components";

const MenuItemStyled = styled(Box)`
  font-size: 14px;
  line-height: 150%;
  color: white;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

export default function HeaderNavDropdown({
  label,
  links = [],
  active = false,
  bg: _bg = "dark",
  display
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const history = useHistory();

  if (!links.length) {
    return null;
  }

  const handleItemClick = (to, newTab) => {
    if (newTab) {
      window.open(to, "_blank");
    } else {
      history.push(to);
    }
    setMenuOpen(false);
  };

  const bg = !menuOpen ? _bg : "#282828";

  return (
    <Menu
      opened={menuOpen}
      onChange={setMenuOpen}
      trigger="click"
      placement="bottom-start"
      allowedPlacements={["bottom-start"]}
    >
      <Menu.Target>
        <ButtonV2
          rightIcon={
            <ChevronComponent direction={menuOpen ? "top" : "bottom"} width={5} fill="white" />
          }
          p={16}
          letterSpacing="unset"
          textTransform="unset"
          fontSize={16}
          gap={10}
          size={null}
          color={active ? "green" : "white"}
          bg={bg}
          height={[48, 48, 60]}
          borderRadius={0}
          display={display}
          data-component-name={`HeaderNavDropdown:${label}`}
        >
          {label}
        </ButtonV2>
      </Menu.Target>
      <Menu.Dropdown
        bg={bg}
        borderRadius={12}
        minWidth={240}
        px="8px"
        py={28}
        data-component-name={`HeaderNavDropdownMenu:${label}`}
        borderTopLeftRadius={0}
      >
        <Box pl="8px">
          {links.map(link => (
            <MenuItemStyled
              key={link.label}
              onClick={() => handleItemClick(link.href || link.to, link.newTab)}
              fontFamily="gilroyMedium"
            >
              {link.activeTest?.() && (
                <Circle bg="green" size={5} position="relative" left="-15px" top="10px" />
              )}
              {link.label}
            </MenuItemStyled>
          ))}
        </Box>
      </Menu.Dropdown>
    </Menu>
  );
}
